import React, { Component } from "react";
import {
    Row,
    Col,
    Form,
    Space,
    Button,
    Select,
    Input,
    message,
    Checkbox,
    Table,
    Tooltip,
} from "antd";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

import AssignDriverToUserStore from "../store/AssignDriverToUserStore";
import UsersStore from "../store/UsersStore";
import { DeleteFilled } from "@ant-design/icons";
import config from "../config";
import ListTable from "./ListTable";
import { update } from "lodash";
import DriversStore from "../store/DriversStore";

class AssignDriverToUser extends Component {
    constructor(props) {
        super(props);
        // this.handleChange = this.handleChange.bind(this);
        this.assignDriverToUserStore = new AssignDriverToUserStore();
        this.UsersStore = new UsersStore();
        this.driverStore = new DriversStore();

        this.formRef = React.createRef();
        this.state = {
            loading: false,
            loadList: 0,
            companyId: "",
            selectedGroup: "",
            text: "",
            selectedDriver: "",
            all: false,
            assignDrivers: [],
            selectedDriversData: [],
            selectedRemove: [],
            groupId: "",
            openAssignForm: false,
            allAssignDriversArra: [],
            allUnAssignedDrivers: [],
            hideTblDta: false,
            assignAllSelectedGroup: false,
            swapCounter: 0,
            driverList: [],
        };


    }
    onDeleteRow = async (index, driverId) => {
        if (this.state.assignAllSelectedGroup) {
            return;
        }
        const filterSelectedDriver = this.state.selectedDriver?.filter(
            (val) => val !== driverId
        );
        const filterData = this.state.assignDrivers.filter(
            (val, indexx) => indexx !== index
        );
        const filterData1 = this.state.allAssignDriversArra.filter(
            (val, indexx) => indexx !== index
        );
        console.log(filterData);
        this.setState({
            selectedDriversData: filterData1,
            assignDrivers: filterData,
            allAssignDriversArra: filterData1,
            selectedDriver: filterSelectedDriver
        });
    }
    async componentDidMount() {
        console.log(this.props);
        this.columns = [
            {
                title: this.context.translate("_DRIVER_"),
                dataIndex: "name",
            },
        ];
        this.columns1 = [
            {
                title: this.context.translate("_ASSIGNED_DRIVERS_"),
                dataIndex: "name",
                key: "driverId",
                // width: "15%",
            },
            {
                // title: "Remove",
                title: this.context.translate("_REMOVE_"),
                dataIndex: "action",
                render: (text, record, index) => {
                    // console.log(record, index);
                    return (
                        <>
                            <Space>
                                <Tooltip
                                    // title="Remove"
                                    title={this.context.translate("_REMOVE_")}
                                    color={config.tooltipColorDelete}
                                >
                                    <Link
                                        onClick={async () => {
                                            await this.onDeleteRow(index, Number(record.driverId));
                                            console.log(record, text);
                                        }}
                                    >
                                        {" "}
                                        <DeleteFilled style={{ color: config.deleteColor }} />
                                    </Link>
                                </Tooltip>
                            </Space>
                        </>
                    );
                },
            },
        ];

        const data = await this.assignDriverToUserStore.getDriveGroup({
            companyId: this.props.companyId,
        });

        const res = await this.assignDriverToUserStore.getAllUserDrivers({
            companyId: this.props.companyId,
            userId: this.props.userId,
        });
        console.log(res);
        if (res) {
            if (res.groups[0].drgId) {
                await this.getGroupofDrivers(res.groups[0]);
                this.formRef.current.setFieldsValue({ drgId: res.groups[0].drgId });

            }
            const assignedDrivers = this.assignDriverToUserStore.assignedDriverList || [];

            if (assignedDrivers.length > 0) {
                console.log(assignedDrivers)

                await this.setState({
                    allAssignDriversArra: assignedDrivers,
                    selectedDriversData: assignedDrivers,
                    selectedDriver: assignedDrivers.map((item) =>
                        Number(item.driverId)
                    ),
                    assignDrivers: assignedDrivers.map((item) =>
                        Number(item.driverId)
                    ),
                })

            }

        }
        else {
            await this.driverStore.toGetDriverName(this.props.companyId);
            await this.setState({
                driverList: this.driverStore?.getDriverName
            })
        }

        this.setState({ update: 1 })
    }


    async getGroupofDrivers(dta) {
        const data = await this.assignDriverToUserStore.getGroupofDrivers({
            drgId: dta.drgId,
            companyId: this.props.companyId,
        });

        this.setState({
            driverList: this.assignDriverToUserStore.driverList,

        })


    }
    searchInput = (e) => {
        this.setState({ text: e.target.value });


    };

    handleRemoveSelected = async (selectedRowKeys) => {
        if (this.state.assignAllSelectedGroup) {
            return;
        }
        let filteredX = this.state.selectedDriver?.filter((element) => {
            if (!this.state.selectedRemove?.includes(element)) return element;
        });

        this.setState({ selectedDriver: filteredX });

        let arr = [];
        this.state.allAssignDriversArra.forEach((val) => {
            if (!this.state.selectedRemove.includes(val.driverId)) {
                arr.push(val);
            }
        });
        this.setState({ selectedDriversData: arr, allAssignDriversArra: arr });
    };

    handleRemoveAll = async () => {
        if (this.state.assignAllSelectedGroup) {
            return;
        }
        this.setState({ selectedDriver: [], selectedDriversData: [], allAssignDriversArra: [] });
    };

    onAssignDriverToUser = async (values) => {
        this.setState({ loading: true });
        console.log(values, this.state.selectedDriver, this.props.userId);
        const data = {
            drgId: values.drgId,
            driverId: this.state.selectedDriver,
            userId: this.props.userId,
            companyId: this.props.companyId
        }
        const response = await this.assignDriverToUserStore.toAssignDriverToUser(data);
        this.setState({ loading: false });
        await this.context.viewStateStore.setUserAddStates({
            companyId: this.props.companyId,
        });
        await this.props.response(response);

    }

    render() {
        return (
            <div style={{ padding: 0 }}>
                <div style={{ paddingBottom: "10px" }}>
                    <Form
                        style={{ maxWidth: "100%" }}
                        ref={this.formRef}
                        layout="vertical"
                        onFinish={this.onAssignDriverToUser}
                        {...this.layout}
                        name="nest-message"
                        className="formClass"
                    >
                        <Row className="overflowFormInputs">
                            <Col span={24} className="formColumnClass">
                                <Form.Item
                                    name="drgId"
                                    value={this.state.drgId}

                                    label={this.context.translate(
                                        "_DRIVER_GROUPS_"
                                    )}
                                    className="search-field"
                                >
                                    <Select
                                        // mode="multiple"
                                        dropdownStyle={{ overflowY: "auto" }}
                                        maxTagCount="responsive"
                                        fieldNames={{ label: "groupName", value: "drgId" }}
                                        placeholder={this.context.translate(
                                            "_DRIVER_GROUPS_"
                                        )}
                                        optionFilterProp="children"
                                        options={this.assignDriverToUserStore?.driverGroupDrivers}
                                        value={this.state.selectedGroup}
                                        onChange={async (val, drgId) => {
                                            await this.getGroupofDrivers(drgId);
                                            await this.setState({ selectedGroup: drgId });

                                            console.log(drgId);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name=""
                                    // label="Search Vehicle"
                                    label={this.context.translate("_SEARCH_DRIVER_")}
                                >
                                    <Input
                                        onChange={async (e) => {
                                            await this.setState({ text: e.target.value });
                                            // await this.searchInput(e);
                                            console.log(e.target.value);
                                        }}
                                    />
                                </Form.Item>
                                <br></br>
                                <Row>
                                    <Col span={11}>
                                        <Table
                                            // style={{height:300}}
                                            scroll={{
                                                x: 240,
                                                y: 300,
                                            }}
                                            pagination={false}
                                            bordered
                                            rowKey="driverId"
                                            columns={this.columns}
                                            rowSelection={{
                                                selectedRowKeys: this.state.selectedDriver,
                                                onChange: async (selectedRowKeys, selectedRows) => {

                                                    if (this.state.assignAllSelectedGroup) {
                                                        return;
                                                    }

                                                    let finalSelectedDrivers = [...this.state.allAssignDriversArra];

                                                    selectedRows.forEach((row) => {
                                                        const exists = finalSelectedDrivers.find(
                                                            (item) => Number(item.driverId) === Number(row.driverId)
                                                        );

                                                        if (!exists) {
                                                            finalSelectedDrivers.push(row);
                                                        }
                                                    });

                                                    finalSelectedDrivers = finalSelectedDrivers.filter((item) =>
                                                        selectedRowKeys.includes(Number(item.driverId))
                                                    );

                                                    await this.setState({
                                                        selectedDriver: finalSelectedDrivers.map((item) =>
                                                            Number(item.driverId)
                                                        ),
                                                        assignDrivers: finalSelectedDrivers.map((item) =>
                                                            Number(item.driverId)
                                                        ),
                                                        selectedDriversData: finalSelectedDrivers,
                                                        allAssignDriversArra: finalSelectedDrivers,
                                                    });
                                                }
                                                // selectedRowKeys: this.state.assignDrivers,
                                            }}
                                            dataSource={
                                                (this.state.driverList || []).map((item) => ({
                                                    ...item,
                                                    driverId: Number(item.driverId),
                                                })).filter((item) => {

                                                    const search = (this.state.text || "")
                                                        .toLowerCase()
                                                        .replace(/\s+/g, "");

                                                    const driverName = (item.name || "")
                                                        .toLowerCase()
                                                        .replace(/\s+/g, "");

                                                    return driverName.includes(search);
                                                })
                                            }
                                        />
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col span={11}>
                                        <Table
                                            scroll={{
                                                x: 240,
                                                y: 300,
                                            }}
                                            pagination={false}
                                            bordered
                                            rowSelection={{
                                                selectedRowKeys: this.state.selectedRowKeys?.map(
                                                    (val) => {
                                                        return val.driverId;
                                                    }
                                                ),
                                                onChange: async (selectedRowKeys, selectedRows) => {
                                                    console.log(selectedRowKeys);
                                                    this.setState({ selectedRemove: selectedRowKeys });
                                                },
                                            }}
                                            // total={this.UsersStore?.total}
                                            rowKey="driverId"
                                            columns={this.columns1}
                                            dataSource={
                                                // this.driverStore?.getDriverName
                                                this.state.allAssignDriversArra
                                                // ? this.state.allAssignDriversArra
                                                // : this.state.selectedDriversData
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <div className="formBtnGroup">
                            <Button
                                disabled={this.state.assignAllSelectedGroup}
                                type="primary"
                                className="formSaveButton"
                                onClick={this.handleRemoveSelected}
                            >
                                {/* Remove */}
                                {this.context.translate("_REMOVE_")}
                            </Button>
                            <Button
                                disabled={this.state.assignAllSelectedGroup}
                                type="primary"
                                style={{ width: "113px" }}
                                className="formSaveButton"
                                onClick={this.handleRemoveAll}
                            >
                                {/* Remove All */}
                                {this.context.translate("_REMOVE_ALL_")}
                            </Button>

                            <Button
                                loading={this.state.loading}
                                type="primary"
                                htmlType="submit"
                                className="formSaveButton"
                            >
                                {/* Save */}
                                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

AssignDriverToUser.contextType = StoreContext;
export default observer(withRouter(AssignDriverToUser));
